import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import SefrakMinne from './SefrakMinne.jsx'
import SefrakMinneIcon from '../../../images/SefrakMinne.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class SefrakMinneList extends Component {
    state = {
        sefrakMinner: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getSefrakMinner = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/sefrakminne`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken                
            }
        })
        .then(({data}) => {
            this.setState({
                sefrakMinner: [...this.state.sefrakMinner, ...data.sefrakMinner],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }


    toggleSefrakMinner = () => {
        if (this.props.antall == 0) return

        if (this.state.sefrakMinner.length == 0) {
            this.getSefrakMinner()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallSefrakMinner = this.state.continuationToken ? `${this.state.sefrakMinner.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleSefrakMinner}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={SefrakMinneIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('sefrakminner')} ({antallSefrakMinner})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.sefrakMinner.length > 0 ? "" : "collapsed"}>
                    <ul>
                        {this.state.sefrakMinner.map((s, index) => { return (<SefrakMinne key={s.sefrakMinneId} sefrakminne={s} antall={this.props.antall} isLast={index==this.state.sefrakMinner.length-1} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getSefrakMinner}>
                                <span>{t('hent.sefrakminner')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(SefrakMinneList)